module.exports = __webpack_public_path__ + "images/98ee846e92c7336feeca728b9a81d69afedcc400b01955a14d9d7fdbd052f112.svg";